import { createSelector } from '@ngrx/store';

import { productRestrictionsState } from '../root';

export const isProductRestrictionsLoading = createSelector(
    productRestrictionsState,
    productRestrictions => productRestrictions.isDownloading
);
